import { isBlank, isNullOrUndefined } from "@/utils/ts-utils"

export default (value?: string | number | null): number | undefined => {
  if (isNullOrUndefined(value) || isBlank(value?.toString())) return undefined
  const nb = Number.parseFloat(value.toString())
  return Number.isNaN(nb) ? undefined : nb
}
